<template>
  <div id="login">
    <h2>Login</h2>
    <div class="card w-50 mx-auto">
      <div class="card-body">
        <persist-user />
      </div>
    </div>
  </div>
</template>

<script>
import PersistUser from '../../components/PersistUser.vue';
export default {
  components: { PersistUser },};
</script>
<style lang="scss">
  #login{
    margin-top: 80px;
  }
</style>